import type { Dispatch } from 'redux';

import { createSwitchlessReducer } from '../util/switchlessReducer';
import { createAccountIdChangedCaseReducer } from '../auth/useAccountId';

export const namespace = 'app_messages';

export type Message = Readonly<{
    text: string;
    id: string;
    severity: 'info' | 'warning' | 'error' | 'success';
}>;

export interface MessagesState {
    messages: Message[];
}

export const initialMessagesState: MessagesState = {
    messages: [],
};

export const { reducer, actions } = createSwitchlessReducer({
    namespace: namespace,
    initialState: initialMessagesState,
    reducers: {
        appendMessage: (state: MessagesState, message: Message) => {
            return {
                messages: [...state.messages, message],
            };
        },
        removeVisibleMessage: (state: MessagesState) => {
            return {
                messages: state.messages.slice(1),
            };
        },
    },
    globalReducer: createAccountIdChangedCaseReducer(() => initialMessagesState),
});

const generateId = () => {
    return (
        new Date().valueOf() +
        Math.random()
            .toString(36)
            .substring(7)
    );
};

export const createMessagesActions = (dispatch: Dispatch) => {
    const addMessage = async (message: Omit<Message, 'id'>) => {
        const messageWithId = {
            ...message,
            id: generateId(),
        };
        dispatch(actions.appendMessage(messageWithId));
        return messageWithId;
    };
    const removeVisibleMessage = () => dispatch(actions.removeVisibleMessage());
    return {
        addMessage,
        removeVisibleMessage,
    };
};
